import * as t from "io-ts";
import {ObjectDocumentAssocValidator} from "./object-document-assoc";
import {ObjectPictureAssocArrayValidator} from "./object-picture-assoc";

export const SupplementalValidator = t.intersection([
  ObjectDocumentAssocValidator,
  ObjectPictureAssocArrayValidator,
]);

export const SupplementalArrayValidator = t.array(SupplementalValidator);

export type Supplemental = t.TypeOf<typeof SupplementalValidator>;
export type SupplementalArray = t.TypeOf<typeof SupplementalArrayValidator>;
